export const notuseUsername:RegExp[] = [ // 利用不可能なユーザー名リスト
    /^(?=.*名前は.+方が有利)(?!.*最低|.*反対)/gu,
    /^(?=.*NMNGyuri)(?!.*最低|.*反対)/giu,
    /^(?=.*マイ鉄ネット)(?!.*最低|.*反対)/gu,
    /^(?=.*アソライ)(?!.*最低|.*反対)/gu,
    /^(?=.*daichan)(?!.*最低|.*反対)/gui,
    /^(?=.*BMR)(?!.*最低|.*反対)/gui,
    /^(?=.*パグリー)(?!.*最低|.*反対)/gu,
    /^(?=.*がまねむ)(?!.*最低|.*反対)/gu,
    /^(?=.*limiter)(?!.*最低|.*反対)/gui,
    /^(?=.*Bedrock.*?Minecraft.*?Railway)(?!.*最低|.*反対)/gui,
    /^(?=.*ゆどうふ)(?!.*最低|.*反対)/gu,
    /^(?=.*九尾)(?!.*最低|.*反対)/gu,
    /^(?=.*蒼雪もなか)(?!.*最低|.*反対)/gu,
    /^(?=.*牛3円偽)(?!.*最低|.*反対)/gui,
    /^(?=.*㍌村I鶏煎餅)(?!.*最低|.*反対)/gui,
    /^(?=.*たこたこ焼き)(?!.*最低|.*反対)/gu,
    /^(?=.*熟成牛タン)(?!.*最低|.*反対)/gu,
    /^(?=.*高浜電気鉄道)(?!.*最低|.*反対)/gu,
    /^(?=.*秋月)(?!.*最低|.*反対)/gu,
    /^(?=.*ウォーターチャレンジ)(?!.*最低|.*反対).+$/gu,
    /^(?=.*すまない先生)(?!.*最低|.*反対)/gu,
    /^(?=.*マグロのユッケ)(?!.*最低|.*反対)/gu,
    /^(?=.*WhitePAWA)(?!.*最低|.*反対)/gui,
    /^(?=.*ミニトマト隊)(?!.*最低|.*反対)/gu,
    /^(?=.*マイ鉄.*?荒らし対策委員会)(?!.*最低|.*反対)/gu,
    /^(?=.*おいしいご飯)(?!.*最低|.*反対)/gu,
    /^(?=.*小高鉄道)(?!.*最低|.*反対)/gu, // 匿名しゃけと同一人物の可能性があるので一応
    /^(?=.*おだ鉄)(?!.*最低|.*反対)/gu, // 上記と同じ
    /^(?=.*匿名しゃけ)(?!.*最低|.*反対)/gu,
    /^(?=.*元神.*?魔王)(?!.*最低|.*反対)/gu,
    /^(?=.*カービィ大好き)(?!.*最低|.*反対)/gu,
    /^(?=.*あもあすなのだ)(?!.*最低|.*反対)/gu,
    /^(?=.*仮想交通ネットワーク)(?!.*最低|.*反対)/gu,
    /^(?=.*森樹3.*?sinju)(?!.*最低|.*反対)/gui,
    /^(?=.*Atuki)(?!.*最低|.*反対)/gui,
    /^(?=.*大豆)(?!.*最低|.*反対)/gu,
    /^(?=.*yuki)(?!.*最低|.*反対)/gui,
    /^(?=.*KIRE猫)(?!.*最低|.*反対)/gui,
    /^(?=.*いちごミルクの素)(?!.*最低|.*反対)/gu,
    /^(?=.*インポスター引きたい)(?!.*最低|.*反対)/gu,
    /^(?=.*カワシマ)(?!.*最低|.*反対)/gu,
    /^(?=.*シェマー)(?!.*最低|.*反対)/gu,
    /^(?=.*悠仁)(?!.*最低|.*反対)/gu,
    /^(?=.*秋篠宮)(?!.*最低|.*反対)/gu,
    /^(?=.*佳子)(?!.*最低|.*反対)/gu,
    /^(?=.*愛子)(?!.*最低|.*反対)/gu,
    /^(?=.*紀子)(?!.*最低|.*反対)/gu,
    /^(?=.*天皇)(?!.*最低|.*反対)/gu,
    /^(?=.*あもあす大好き)(?!.*最低|.*反対)/gu,
    /^(?=.*mod大好き)(?!.*最低|.*反対)/gu,
    /^(?=.*unicef)(?!.*最低|.*反対)/gui,
    /^(?=.*ゆにせふ)(?!.*最低|.*反対)/gu,
    /^(?=.*ユニセフ)(?!.*最低|.*反対)/gu,
    /^(?=.*国勢調査)(?!.*最低|.*反対)/gu,
    /^(?=.*なまえはながいほうがゆうり)(?!.*さいてい)/gu,
    /^(?=.*ナマエハナガイホウガユウリ)(?!.*サイテイ)/gu,
    /^(?=.*ﾅﾏｴﾊﾅｶﾞｲﾎｳｶﾞﾕｳﾘ)(?!.*ｻｲﾃｲ)/gu,
    /^(?=.*[なまな|なまなが])(?!.*最低|.*反対)/gu,
    /^(?=.*概要欄)(?!.*見るな)/gu,
    /^(?=.*葡々漬)(?!.*最低|.*反対)/gu,
    /^(?=.*SENAにゃん)(?!.*最低|.*反対)/gu,
    /^(?=.*キョンch)(?!.*最低|.*反対)/gui,
    /^(?=.*トラくんの家)(?!.*最低|.*反対)/gu,
    /^(?=.*まひとくん)(?!.*最低|.*反対)/gu,
    /^(?=.*てきと)(?!.*最低|.*反対)/gu,
    /^(?=.*れじぇくん)(?!.*最低|.*反対)/gu,
    /^(?=.*Tipica)(?!.*最低|.*反対)/gui,
    /^(?=.*Sogoca)(?!.*最低|.*反対)/gui,
];

export const blockedIP:RegExp[] = [ // ブロックするipリスト
    /101.111.180.186/gu,
    /118.9.16.2/gu,
    /126.219.88.117/gu,
    /211.132.93.141/gu,
    /118.241.250.176/gu,
    /219.104.135.53/gu,
    /49.109.163.33/gu,
    /118.7.71.129/gu,
    /124.18.233.93/gu,
    /111.188.188.186/gu,
    /60.94.79.163/gu,
    /14.9.13.224/gu,
    /122.135.139.195/gu,
    /14.9.86.64/gu,
    /153.242.253.143/gu,
    /138.201.224.59/gu,
    /221.44.137.228/gu,
    /122.196.202.142/gu
]

export const adminerUserId:string[] = [ // 管理者のuser_idリスト
    "9d2347a2-6322-4d55-93f1-71d8440e5f32",
    "6533d1b6-7ff1-44ce-8375-ef17961fc1af",
    "ba159f68-814f-4564-935f-cea46624fd53",
    "96b00cd8-d43b-4a5b-b473-84433c0b3c98",
    "cdbe8411-64a9-4931-ac89-1e8953014435",
];

export const asakuraMenberUserId:string[] = [
    "9d2347a2-6322-4d55-93f1-71d8440e5f32",
    "6533d1b6-7ff1-44ce-8375-ef17961fc1af",
    "ba159f68-814f-4564-935f-cea46624fd53",
    "96b00cd8-d43b-4a5b-b473-84433c0b3c98",
    "cdbe8411-64a9-4931-ac89-1e8953014435",
]